"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedphonesm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedphonesm` : '') + (description ? ` desc-brandedphonesm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedphonesm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedphonesm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.25 2.25c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v19.5c0 .83-.67 1.5-1.5 1.5H1.75a1.5 1.5 0 0 1-1.5-1.5V2.25Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 3h12v16.5H1V3Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "7.125",
    cy: "21.125",
    r: "1.125",
    fill: "#6E6E6E"
  }));
};
var _default = exports.default = brandedphonesm;